

export default function sanitiseUrls(url = '') {
	return (url.startsWith('http') ? url.replace(/https?:\/\/.*?\//, '/') : url );
}



// WEBPACK FOOTER //
// ./src/utils/sanitiseUrls.js